import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticlePage from "../pages/blog/post/page";
import HowToUsePage from "../pages/blog/how-to-use/page";
import SafetyReviewPage from "../pages/blog/is-safe/page";
import ShoesGuidePage from "../pages/blog/shoes-guide/page";
import TopProductsPage from "../pages/blog/top-products/page";
import VsOthersPage from "../pages/blog/vs-others/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/best-kakobuy-spreadsheet-2026-updated-weekly",
    element: <BlogArticlePage />,
  },
  {
    path: "/how-to-use-kakobuy-spreadsheet",
    element: <HowToUsePage />,
  },
  {
    path: "/is-kakobuy-spreadsheet-safe",
    element: <SafetyReviewPage />,
  },
  {
    path: "/kakobuy-spreadsheet-shoes-guide",
    element: <ShoesGuidePage />,
  },
  {
    path: "/top-kakobuy-spreadsheet-products-2026",
    element: <TopProductsPage />,
  },
  {
    path: "/kakobuy-spreadsheet-vs-others",
    element: <VsOthersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;